<script setup lang="ts">
import { PropertyRowProps } from "./PropertyRow.props"

defineProps<PropertyRowProps>()
</script>

<template>
  <div class="container-utils-property text-black-80 flex justify-between">
    <div class="bg-grey-60 flex flex-1 gap-2 px-2 py-4 md:p-4">
      <div class="flex items-center [&>img]:h-5 [&>img]:w-5">
        <slot name="icon"></slot>
      </div>
      <p v-if="title" class="beaver-bold md:pig-bold">
        {{ title }}
      </p>
    </div>
    <div class="flex flex-1 items-center px-2 py-4 md:p-4">
      <UtilsMarkdown
        v-if="description"
        :content="description"
        class="
          beaver
          markdown__link-underlined
          markdown__link-green-main
          markdown__link-beaver-medium
          word-break-word
        "
      />
    </div>
  </div>
</template>

<style scoped>

.word-break-word {
  word-break: break-word;
}

</style>
